import React from "react";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useFiling } from "../../contexts/FilingContext";
import EmptyStateView from "../../components/EmptyStateView";
import FilingListItem from "./components/FilingListItem";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import { useCreateFilingDialog } from "../../providers/CreateFilingDialogProvider";
import { Button } from "../../design/button";
import { PlusIcon } from "@heroicons/react/20/solid";

const FilingListPage: React.FC = () => {
  const { openDialog } = useCreateFilingDialog();
  const { filings, loading, error } = useFiling();

  if (loading.list) {
    return <LoadingView title="Loading Filings..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between gap-4 mb-6">
        <Heading className="text-2xl font-bold">Filings</Heading>
        <Button onClick={() => openDialog()}>
          <div className="flex items-center gap-2">
            <PlusIcon className="w-4 h-4" />
            <span className="hidden sm:block">Upload Filing</span>
          </div>
        </Button>
      </div>
      {filings.length === 0 && (
        <EmptyStateView
          title="No Filings"
          message="No filings found. Create some to get started."
        />
      )}
      {filings.length > 0 && (
        <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader className="text-left">Name</TableHeader>
              <TableHeader>Side</TableHeader>
              <TableHeader>Filed On</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {filings.map((filing) => (
              <FilingListItem key={filing._id} filing={filing} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default FilingListPage;
